import { render, staticRenderFns } from "./BaseAdd.vue?vue&type=template&id=717a2eb9&scoped=true"
import script from "./BaseAdd.vue?vue&type=script&lang=js"
export * from "./BaseAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717a2eb9",
  null
  
)

export default component.exports